import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';

import { URLS } from 'config';
import { setStorage } from 'utilz';

import sedan from './images/sedan.jpg';
import van from './images/van.jpg';
import truck from './images/truck.jpg';
import suv from './images/suv.jpg';

import './styles.scss';
import containerActions from './actions';

class CarTypePage extends React.Component {
  carTypes = [
    {
      id: 'SEDAN',
      image: sedan,
      text: 'Sedan'
    },
    {
      id: 'VAN',
      image: van,
      text: 'VAN'
    },
    {
      id: 'TRUCK',
      image: truck,
      text: 'Truck'
    },
    {
      id: 'SUV',
      image: suv,
      text: 'SUV'
    }
  ]

  selectCarHand = checkedCar => () => {
    setStorage({
      carType: {
        carType: checkedCar
      }
    });
    this.props.carTypeChangeHandl(checkedCar);
  };

  render() {
    return (
      <div className="page-cartype">
        <PageTitle>What type of car you need?</PageTitle>
        <div className="cartype-list">
          {this.carTypes.map(type => (
            // eslint-disable-next-line
            <div
              className={`cartype-item ${
                this.props.carType === type.id ? '-checked' : ''
              }`}
              onClick={this.selectCarHand(type.id)}
              key={type.id}
            >
              <div className="item-image">
                <i className="icon-check" />
                <div
                  className="image-content"
                  style={{ backgroundImage: `url(${type.image})` }}
                />
              </div>
              <p className="item-info">{type.text}</p>
            </div>
          ))}
        </div>
        <Button isLink pathTo={URLS.BUDGET} disabled={!this.props.carType}>
          Next step
        </Button>
      </div>
    );
  }
}

CarTypePage.propTypes = {
  carType: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  carTypeChangeHandl: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  carType: state.carType.carType
});


export default connect(mapStateToProps, containerActions)(CarTypePage);



// WEBPACK FOOTER //
// ./src/pages/CarType/index.js